import { Link } from 'react-router';

import { Card, Page } from '../layout/Page';

export function NotFoundPage({ returnTo = '/' }: { returnTo?: string }) {
  return (
    <Page
      eyebrow="404"
      title="Workspace not found"
      description="The requested Flow Wizard page does not exist."
    >
      <Card className="empty-state">
        <p>Return home to choose an available workspace.</p>
        <Link className="button button--primary" to={returnTo}>
          Go to Flow Wizard home
        </Link>
      </Card>
    </Page>
  );
}
